module.exports = __webpack_public_path__ + "img/mq-logo.8b10272e.png";